module.exports = "/images/goBackArrowSearch.svg";